import './App.scss';
import Header from './components/Header/Header';
import {  Outlet, useLocation } from 'react-router-dom';
import { Provider, useDispatch, useSelector } from 'react-redux';
import store from './store/store';
import { SideMenu } from './components/SideMenu/SideMenu';
import { Suspense, useEffect, useState } from 'react';
import {
  AuthenticatedTemplate,
  MsalAuthenticationTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from '@azure/msal-react';
import { Button, LoadingIndicator, ToastMessage } from './components';
import { InteractionType } from '@azure/msal-browser';
import axios from 'axios';
import { useGetToken } from './hooks/useAppToken';
import { setUser } from './store/slices/userSlice';
import { AutoLogout } from './components/AutoLogout/AutoLogout';
import { routes } from './routes/routes.constatns';
import { clickMe, HTTP_STATUS_CODES, wafErrorMessage, BAD_REQUEST_ERROR_MESSAGE } from './util/constants';
import { MotifProgressLoader } from './assets/lib/motif';
import { getCurrentSessionId, initializeSession } from './util/session.service';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorBoundaryMessage from './components/ErrorBoundaryMessage';
import { setWafErrorFlag } from './store/slices/projectSlice';


function App() {
  const [isSideMenuCollapsed, setSideMenuCollapsed] = useState(true);
  const { instance, accounts } = useMsal();
  const [isConfigSet, setIsConfigSet] = useState(false);
  const token = useGetToken();
  const account = accounts[0];
  const location = useLocation();
  const popup = location.pathname.includes(routes.decarbProjectsLibrary);
  const dispatch = useDispatch();
  const selectedRegion = useSelector(state => state.engagement.selectedRegion);
  const [toastMessage, setToastMessage] = useState(false);
  const [toastContent, setToastContent] = useState('');

  useEffect(() => {
    initializeSession();
  }, []);

  useEffect(() => {
    if (!account) return;
    dispatch(setUser(account));
    instance.setActiveAccount(account);
  }, [account, instance, dispatch]);

  useEffect(() => {
    if (!token || !account) return;

    axios.interceptors.request.use(async config => {
      if (!config.headers['Authorization'])
        config.headers['Authorization'] = `Bearer ${token}`;
      config.baseURL =
        selectedRegion.apiUrl ?? process.env.REACT_APP_API_URL_DEFAULT;
      config.headers['X-Frame-Options'] = 'DENY';
      config.headers['Content-Security-Policy'] = "frame-ancestors 'none'";
      config.headers['secure'] = true;
      config.headers['httpOnly'] = true;
      config.headers['X-Window-Id'] = getCurrentSessionId();
      return config;
    });
    axios.interceptors.response.use(
      resp => {
        return resp;
      },
      error => {
        if (error?.response?.status === HTTP_STATUS_CODES.BAD_REQUEST) {
          const errorMessage = BAD_REQUEST_ERROR_MESSAGE || error?.response?.data?.message;
          setToastContent(errorMessage);
          setToastMessage(true);
          return Promise.reject(error);
        } else if (error?.response?.status === HTTP_STATUS_CODES.SESSION_TIMEOUT) {
          console.log('HTTP_STATUS_CODES.SESSION_TIMEOUT', HTTP_STATUS_CODES.SESSION_TIMEOUT)
          instance.logoutRedirect({
            account: instance.getActiveAccount(),
            postLogoutRedirectUri: `${process.env.REACT_APP_URL_REG_ALL}${routes.home}`,
          });
        } else if (error?.response?.status === HTTP_STATUS_CODES.FORBIDDEN) {
          dispatch(setWafErrorFlag(true));
        } else if (error?.code === 'ERR_NETWORK') {
          dispatch(setWafErrorFlag(true));
        }
        return Promise.reject(error);
      }
    );

    setIsConfigSet(true);
  }, [token, account, dispatch, selectedRegion?.apiUrl]);

  useEffect(() => {
    if (window.top !== window.self) {
      window.top.location = window.self.location;
    }
  }, []);

  useEffect(() => {
    if (toastMessage) {
      const timer = setTimeout(() => {
        setToastMessage(false);
        setToastContent('');
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [toastMessage]);

  const initializeSignIn = () => {
    instance.loginRedirect();
  };

  return (
    <ErrorBoundary FallbackComponent={ErrorBoundaryMessage}>
        <Suspense fallback={<MotifProgressLoader show />}>
          {toastMessage && (
            <ToastMessage
              variant="error"
              message={toastContent}
              onClose={() => {
                setToastMessage(false);
                setToastContent('');
              }}
              className="global-toast-message"
            />
          )}
          <div className="motif-theme-dark main-div">
            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
              <AuthenticatedTemplate>
                <Provider store={store}>
                  <AutoLogout />
                  <LoadingIndicator show={!isConfigSet} fullscreen={true}>
                    <div className="App">
                      <Header
                        setSideMenuCollapsed={() =>
                          setSideMenuCollapsed(!isSideMenuCollapsed)
                        }
                      />
                      <div className="app-body">
                        {popup ? (
                          <></>
                        ) : (
                          <SideMenu isSideMenuCollapsed={isSideMenuCollapsed} />
                        )}
                        <div
                          className={`app-body-content ${
                            popup
                              ? 'decarb-side-menu-hidden'
                              : isSideMenuCollapsed
                              ? 'decarb-side-menu-collapsed'
                              : 'decarb-side-menu-expanded'
                          }`}
                        >
                          <Outlet />
                        </div>
                      </div>
                    </div>
                  </LoadingIndicator>
                </Provider>
              </AuthenticatedTemplate>
              <UnauthenticatedTemplate>
                <div className="App">
                  <Header />
                  <Button className={'asd'} onClick={initializeSignIn}>
                    {clickMe}
                  </Button>
                </div>
              </UnauthenticatedTemplate>
            </MsalAuthenticationTemplate>
          </div>
        </Suspense>
    </ErrorBoundary>
  );
}

export default App;
